import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class ConfirmationDialogConfig {
  /**
   * @description
   * Title that is displayed on the Confirmation Dialog
   */
  title: string;
  /**
   * @description
   * The body of the Confirmation Dialog
   */
  message: string;
  /**
   * @description
   * The text displayed on the Cancel button
   */
  cancelBtnText: string;
  /**
   * @description
   * The text displayed on the Confirm button
   */
  confirmBtnText: string;
  /**
   * @description
   * The chosen color property for the confirm button
   */
  confirmBtnColor: string;
  /**
   * @description
   * The chosen text string to pick a mat-icon
   */
  matIconText: string;
  /**
   * @description
   * The chosen color property for the mat-icon
   */
  matIconColor: string;
  /**
   * @description
   * If exists, the user will be required to enter the object name to delete
   */
  requiredEntry: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  @HostListener('keydown.esc')
  public onEsc() {
    this.cancel();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogConfig,
              public matDialogRef: MatDialogRef<ConfirmationDialogComponent>) {
  }

  ngOnInit() {
    this.data.cancelBtnText = this.data.cancelBtnText || 'Cancel';
    this.data.confirmBtnText = this.data.confirmBtnText || 'Confirm';
    this.data.confirmBtnColor = this.data.confirmBtnColor || 'primary';
  }

  close(response?: any) {
    this.matDialogRef.close(response);
  }

  cancel() {
    this.close(false);
  }

  confirm() {
    this.close(true);
  }
}
